import { postApiRttData } from "@/util/APIUtils";
import { getTokenKey } from "@/util/auth";
import { CLIENT_TYPE, isPubgm } from "@/constant";
import AdjustSDK from "@/util/adjustReport.js";

function getGameID() {
  return window.location.pathname.split('/').slice(-1)[0];
}

let lastCallTime = null; // 上一次调用postApiRtt的时间

export function postApiRtt(path, rtt) {
  // 需要增加两个事件之间的耗时，当rtt为空时，计算上报
  const curTime = Date.now();
  let timeDiff = null;
  if (lastCallTime !== null) {
    timeDiff = curTime - lastCallTime; // 两个事件之间的耗时
  }
  const data = {
    sName: path,
    sToken: getTokenKey(),
    rtt: rtt ? rtt : timeDiff,
    gameID: getGameID(),
    platform: CLIENT_TYPE
  };
  postApiRttData(data);
  lastCallTime = curTime; // 更新上一次调用时间为当前时间
  if (isPubgm()) {
    AdjustSDK.reportEvent(path);
  }
}

export function perfDataCalc() {
  // 计算从导航到所有资源加载完毕的时间
  try {
    const nt = window.performance.getEntriesByType('navigation')[0];
    const time = nt.loadEventEnd - nt.startTime;
    postApiRtt('/resource/load', time);
  } catch {
    return;
  }
}

export function getFCP() {
  if ('PerformanceObserver' in window) {
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntriesByName('first-contentful-paint')) {
        postApiRtt("fcp_time", parseInt(entry.startTime));
          observer.disconnect();  // FCP已捕获，断开观察
        }
    });
    observer.observe({ type: 'paint', buffered: true });
    } else {
        console.log('PerformanceObserver is not supported in this browser.');
    }
}